import { memo } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const StyledList = styled.section`
  display: flex;
  flex-direction: row;
  column-gap: 20px;
  justify-content: center;
  @media (max-width: 600px) {
    display: block;
  }
`;

const StyledLink = styled(Link)`
  font-size: 13px;
  font-weight: normal;
  color: #000000;
  text-decoration: none;
  &:hover {
    color: #000000;
  }
  @media (max-width: 600px) {
    margin: 0px 10px;
  }
`;

const FooterLinks = memo(({ appData }) => {
  return (
    <StyledList>
      {appData?.privacyPolicy && (
        <StyledLink to="/privacy-policy" title="Privacy Policy" target="_blank">
          Privacy Policy
        </StyledLink>
      )}
      {appData?.disclaimers && (
        <StyledLink to="/disclaimers" title="Disclaimers" target="_blank">
          Disclaimers
        </StyledLink>
      )}
      {appData?.termsAndConditions && (
        <StyledLink
          to="/terms-and-conditions"
          title="Terms &amp; Conditions"
          target="_blank"
        >
          Terms &amp; Conditions
        </StyledLink>
      )}
      {appData?.refundPolicy && (
        <StyledLink to="/refund-policy" title="Refund Policy" target="_blank">
          Refund Policy
        </StyledLink>
      )}
    </StyledList>
  );
});

export default FooterLinks;
